<script lang="ts">
export default {
  name: "DocumentTypeRASpro",
  functional: true,
  props: {
    typetranferencia: {
      type: String,
      required: false,
      default: null
    },
    row: Object,
    column: String
  },

  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const valtype = context.props.row.NDocument;

    if (val === 2) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--dark",
          style: "color:white;"
        },
        "Factura"
      );
    }
    if (val == 3) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--dark",
          style: "color:white;"
        },
        "Nota de crédito"
      );
    }
    if (val == 1) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--dark",
          style: "color:white;"
        },
        "Pago"
      );
    }
    if (valtype.match(/TRANSF*/)) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--dark",
          style: "color:white;"
        },
        "Tranferencia"
      );
    }

    return createElement("");
  }
};
</script>
